import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { ApiError, login } from "../api/client";

export function LoginPage() {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(password);
      navigate("/advertisers", { replace: true });
    } catch (caught) {
      // The API deliberately returns one generic failure; do not leak detail.
      setError(caught instanceof ApiError && caught.status === 401 ? "Неверный пароль" : "Не удалось войти");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div style={{ display: "grid", placeItems: "center", minHeight: "100vh" }}>
      <form className="panel" style={{ width: 340 }} onSubmit={submit}>
        <h2>Alot Content</h2>
        <div className="field">
          <label htmlFor="password">Пароль администратора</label>
          <input
            id="password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        {error && <p className="error">{error}</p>}
        <button className="primary" type="submit" disabled={busy || password.length === 0}>
          {busy ? "Вхожу…" : "Войти"}
        </button>
      </form>
    </div>
  );
}
